<template>
    <aside class="flex w-60 shrink-0 flex-col border-r border-surface-200 bg-surface-0 dark:border-surface-800 dark:bg-surface-900">
        <div class="flex h-14 items-center gap-2 px-4 text-lg font-bold">
            <i class="pi pi-clock text-primary" />
            <span>TimeTerminal</span>
        </div>
        <nav class="flex flex-1 flex-col gap-1 p-2">
            <RouterLink
                v-for="item in items"
                :key="item.name"
                v-slot="{ href, navigate, isActive }"
                :to="{ name: item.name }"
                custom
            >
                <a
                    :href="href"
                    :class="[
                        'flex items-center gap-3 rounded-md px-3 py-2 transition-colors',
                        isActive
                            ? 'bg-primary text-white hover:bg-primary-600'
                            : 'text-surface-700 hover:bg-primary/10 hover:text-primary dark:text-surface-200',
                    ]"
                    @click="navigate"
                >
                    <i :class="item.icon" />
                    <span>{{ $t(item.label) }}</span>
                </a>
            </RouterLink>
        </nav>
    </aside>
</template>

<script lang="ts" setup>
    import { computed } from 'vue'

    import { useAppStore } from '@/stores/app'

    const appStore = useAppStore()

    const allItems = [
        { name: 'users', label: 'nav.users', icon: 'pi pi-users', admin: true },
        { name: 'projects', label: 'nav.projects', icon: 'pi pi-folder', admin: true },
        { name: 'devices', label: 'nav.devices', icon: 'pi pi-tablet', admin: false },
        { name: 'module-types', label: 'nav.module_types', icon: 'pi pi-box', admin: true },
        { name: 'managed-play', label: 'nav.managed_play', icon: 'pi pi-google', admin: true },
        { name: 'audit-card-reads', label: 'nav.audit_card_reads', icon: 'pi pi-id-card', admin: false },
        { name: 'audit-exchanges', label: 'nav.audit_exchanges', icon: 'pi pi-arrows-h', admin: false },
        { name: 'audit-events', label: 'nav.audit_events', icon: 'pi pi-list', admin: false },
    ]

    const items = computed(() => allItems.filter((item) => !item.admin || appStore.isAdmin()))
</script>
